import { ContextAction } from '$ops-portal/context/global-context/types';

export type CaseHistoryModalState = {
  isModalOpen: boolean;
  caseId?: string;
  entityId?: string;
};

export type CaseHistoryModalAction =
  | {
      type: ContextAction.setCaseHistory;
      payload: CaseHistoryModalState;
    }
  | { type: ContextAction.resetCaseHistory };

export const ResetCaseHistoryAction: { type: ContextAction.resetCaseHistory } =
  {
    type: ContextAction.resetCaseHistory
  };
